import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnInit,
  Output,
  QueryList,
  ViewChildren,
} from '@angular/core';
import { BrowserService } from '@shared/services/browser.service';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-toggle-switch',
  templateUrl: './toggle-switch.component.html',
  styleUrls: ['./toggle-switch.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ToggleSwitchComponent {
  @Input() value = false;
  @Output() valueChange = new EventEmitter<boolean>();

  @Input() onIcon: string;
  @Input() offIcon: string;

  @Input() onLabel: string;
  @Input() offLabel: string;

  protected switch(): void {
    this.value = !this.value;
    this.valueChange.emit(this.value);
  }
}
